import React from 'react';
import { getInitials } from '../../utils/userUtils';

const ProfileHeader = ({ profile, user }) => {
    return (
        <div className="lg:col-span-1">
            <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl border-slate-200 dark:border-white/10 shadow-xl dark:shadow-2xl rounded-3xl p-8 flex flex-col items-center text-center transition-all">
                <div className="size-32 rounded-full bg-indigo-600 flex items-center justify-center text-5xl font-bold shadow-lg shadow-indigo-500/20 mb-6 text-white">
                    {getInitials(profile?.display_name || user?.displayName)}
                </div>
                <h2 className="text-xl font-bold">{profile?.display_name || user?.displayName}</h2>
                <p className="text-slate-500 dark:text-slate-400 text-sm mb-1">{profile?.email}</p>
                <div className="mt-4 px-3 py-1 bg-slate-100 dark:bg-white/5 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-white/5 rounded-full text-xs font-medium border uppercase tracking-wider">
                    {profile?.role || 'User'}
                </div>
            </div>
        </div>
    );
};

export default ProfileHeader;
